import { css, Theme } from '@emotion/react'

export const switchEl = (theme: Theme) => css`
  margin: 18px 0 26px;

  & .MuiTypography-root {
    font-size: ${theme.typography.body2.fontSize}px;
    line-height: ${theme.typography.body2.lineHeight};
    color: ${theme.typographyColors.typographyThree};
    font-style: italic;
  }
`
